import React from "react";

export const EBillProviderDetailContext = React.createContext(null);

export const useEBillProviderDetailContext = () => {
  const context = React.useContext(EBillProviderDetailContext);

  if (!context) throw new Error("E-Bill Provider Detail Context not provided!");

  return context;
};
